import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyEmployeePolicyAdjustment } from 'src/app/policy/models/CompanyEmployeePolicyAdjustment';
import { PolicyService } from 'src/app/policy/services/policy.service';
import { SummernoteHelper } from 'src/app/shared/common/SummernoteHelper';
import { FlatpickrLocaleService } from 'src/app/shared/services/flatpickr-locale.service';
import { CompanyPolicyDatetimeType } from '../../../../policy/models/CompanyEmployeePolicy';

@Component({
    selector: 'app-create-edit-employee-adjustment-modal',
    templateUrl: './create-edit-employee-adjustment-modal.component.html',
    styleUrls: ['./create-edit-employee-adjustment-modal.component.css']
})
export class CreateEditEmployeeAdjustmentModalComponent implements OnInit {
    public adjustmentEditForm: UntypedFormGroup;
    public submitted = false;
    public employeeID: number;
    public companyEmployeeAdjustment: CompanyEmployeePolicyAdjustment;
    public employeePolicyDatetimes: CompanyPolicyDatetimeType[];
    public locale$ = this._flatpickrLocale.currentFlatpickrLocale$;
    public effectiveFromMinDate = null;

    constructor(
        public activeModal: NgbActiveModal,
        public summernoteHelper: SummernoteHelper,
        private _fb: UntypedFormBuilder,
        private _policyService: PolicyService,
        private _flatpickrLocale: FlatpickrLocaleService,
    ) { }

    public get employeeDatetimeTypes(): FormArray {
        return this.adjustmentEditForm?.get('employee_datetime_types') as FormArray;
    }

    public get f(): { [formControlName: string]: AbstractControl; } {
        return this.adjustmentEditForm.controls;
    }

    public ngOnInit(): void {
        this.adjustmentEditForm = this._fb.group({
            employee_datetime_types: this._fb.array([this.datetimeFormGroup()]),
            effective_from: ['', Validators.required],
            description: ['']
        });

        if (this.companyEmployeeAdjustment?.employee_policy_adjustement_ID) {
            this.adjustmentEditForm.patchValue(this.companyEmployeeAdjustment);
            this.adjustmentEditForm.controls.effective_from.disable();
        }

        const datetimeTypes = this.companyEmployeeAdjustment?.employee_datetime_types || this.employeePolicyDatetimes;
        if (datetimeTypes.length > 0) {
            this.employeeDatetimeTypes.clear();

            datetimeTypes.forEach(type => {
                if (!this.companyEmployeeAdjustment?.employee_datetime_types) {
                    type.hours = null;
                } else {
                    type.hours = type.absolute_hours ?? 0;
                }
                this.addNewDatetimeType(type);
            });
        }
    }

    public datetimeFormGroup(type: CompanyPolicyDatetimeType = null): UntypedFormGroup {
        return this._fb.group({
            employee_datetime_type_ID: [type?.employee_datetime_type_ID ?? null, Validators.required],
            hours: [type?.hours ?? null],
        });
    }

    public addNewDatetimeType(type: CompanyPolicyDatetimeType = null): void {
        this.employeeDatetimeTypes.push(this.datetimeFormGroup(type));
    }

    public onSubmit(): void {
        this.submitted = true;
        if (!this.adjustmentEditForm.valid) {
            return;
        }
        const promise = this._policyService.savePolicyAdjustment(this.adjustmentEditForm.getRawValue(), this.employeeID, this.companyEmployeeAdjustment?.employee_policy_adjustement_ID);
        promise.then(result => this.activeModal.close('saved'));
    }

    public deleteAdjustment(): void {
        const promise = this._policyService.deleteAdjustment(this.employeeID, this.companyEmployeeAdjustment?.employee_policy_adjustement_ID);
        promise.then(result => this.activeModal.close('saved')).catch(() => {});
    }
}
